module.exports = __webpack_public_path__ + "img/20200501_160645.217cc1db.jpg";